// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"68fb7c31","741":"68fb7c31","3122":"68fb7c31","3414":"ca62eefd","3888":"68fb7c31","5585":"ffeea43a","6154":"7cff2fcf"}[chunkId] + ".chunk.css";
};